import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PACKAGING } from "../data/content";
import { Reveal } from "./Reveal";

export const PackagingKit = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="unboxing" ref={ref} data-testid="packaging" className="relative py-28 md:py-44 border-t border-bds-border">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-24">
            <div>
              <span className="font-mono-bds text-xs uppercase tracking-[0.3em] text-bds-accent">The Society Kit</span>
              <h2 className="font-serif-display font-light text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9] mt-6">
                Opened like <span className="italic">a ritual</span>
              </h2>
            </div>
            <p className="font-grotesk text-bds-muted max-w-sm leading-relaxed">
              Every order arrives as a full ceremony — a sealed black box, wax-bound tissue, a numbered membership card, and a note reminding you that you are not alone.
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="relative overflow-hidden border border-bds-border mb-8 md:mb-10 bg-bds-surface">
            <video
              data-testid="unboxing-video"
              className="w-full h-auto max-h-[70vh] object-cover"
              src="/videos/unboxing.mp4"
              poster="/packaging/box.jpg"
              autoPlay
              muted
              loop
              playsInline
            />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 bg-gradient-to-t from-bds-bg via-bds-bg/40 to-transparent pointer-events-none">
              <p className="font-mono-bds text-[11px] uppercase tracking-[0.3em] text-bds-muted mb-2">The Unboxing</p>
              <p className="font-serif-display text-3xl md:text-5xl">Face your demons. Then unwrap them.</p>
            </div>
          </div>
        </Reveal>

        <motion.div style={{ y }} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {PACKAGING.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08}>
              <figure data-testid={`packaging-${i}`} className="group">
                <div className="overflow-hidden border border-bds-border">
                  <img src={p.img} alt={p.title} className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <figcaption className="mt-5">
                  <h3 className="font-serif-display text-2xl">{p.title}</h3>
                  <p className="font-grotesk text-sm text-bds-muted mt-2 leading-relaxed">{p.note}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
